import { loadStoredSession } from "../auth/auth.storage";
import type { AuthSession } from "../auth/models/session.model";
import { buildModuleHandoffUrl } from "../modules/suite-navigation";

/** Module hôte des pages admin tenant unifiées (RH). */
export const TENANT_ADMIN_SHELL_MODULE = "rh";

export function buildTenantAdminHandoffUrl(
  adminBaseUrl: string,
  targetPath: string,
  session: AuthSession | null = loadStoredSession(),
): string | null {
  if (!session) return null;
  return buildModuleHandoffUrl(
    adminBaseUrl,
    "/auth/handoff",
    session,
    targetPath,
  );
}

export function openTenantAdminPage(
  adminBaseUrl: string,
  targetPath: string,
): void {
  const url = buildTenantAdminHandoffUrl(adminBaseUrl, targetPath);
  if (!url) {
    window.alert("Session expirée — reconnectez-vous via ITaaS Suite.");
    return;
  }
  window.location.assign(url);
}
